import axios from "axios";

// API基地址 - 开发环境用代理，生产环境用相对路径
const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE || "",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

// 请求拦截器 - 添加Token
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 响应拦截器 - 处理401
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("admin_token");
      localStorage.removeItem("admin_info");
      window.location.hash = "#/admin/login";
    }
    return Promise.reject(error.response ? error.response.data : error);
  }
);

// =============== 公开 API ===============

export const publicApi = {
  getMenus: () => apiClient.get("/api/public/menus"),
  getContents: () => apiClient.get("/api/public/contents"),
  getContent: (key) => apiClient.get(`/api/public/contents/${key}`),
  getProducts: () => apiClient.get("/api/public/products"),
  getProduct: (id) => apiClient.get(`/api/public/products/${id}`),
  getNewsList: (params) => apiClient.get("/api/public/news", { params }),
  getNewsLatest: () => apiClient.get("/api/public/news/latest"),
  getNewsDetail: (id) => apiClient.get(`/api/public/news/${id}`),
  getCaptcha: () => apiClient.get("/api/public/captcha"),
  submitMessage: (data) => apiClient.post("/api/public/messages", data),
};

// =============== 管理 API ===============

export const adminApi = {
  // 认证
  getCaptcha: () => apiClient.get("/api/admin/captcha"),
  login: (data) => apiClient.post("/api/admin/login", data),
  getInfo: () => apiClient.get("/api/admin/info"),
  changePassword: (data) => apiClient.post("/api/admin/change-password", data),

  // 菜单
  getMenus: () => apiClient.get("/api/admin/menus"),
  createMenu: (data) => apiClient.post("/api/admin/menus", data),
  updateMenu: (id, data) => apiClient.put(`/api/admin/menus/${id}`, data),
  deleteMenu: (id) => apiClient.delete(`/api/admin/menus/${id}`),

  // 站点内容
  getContents: () => apiClient.get("/api/admin/contents"),
  updateContent: (id, data) => apiClient.put(`/api/admin/contents/${id}`, data),

  // 产品
  getProducts: () => apiClient.get("/api/admin/products"),
  getProduct: (id) => apiClient.get(`/api/admin/products/${id}`),
  createProduct: (data) => apiClient.post("/api/admin/products", data),
  updateProduct: (id, data) => apiClient.put(`/api/admin/products/${id}`, data),
  deleteProduct: (id) => apiClient.delete(`/api/admin/products/${id}`),

  // 新闻
  getNewsList: (params) => apiClient.get("/api/admin/news", { params }),
  getNews: (id) => apiClient.get(`/api/admin/news/${id}`),
  createNews: (data) => apiClient.post("/api/admin/news", data),
  updateNews: (id, data) => apiClient.put(`/api/admin/news/${id}`, data),
  deleteNews: (id) => apiClient.delete(`/api/admin/news/${id}`),

  // 留言
  getMessages: (params) => apiClient.get("/api/admin/messages", { params }),
  markMessageRead: (id) => apiClient.put(`/api/admin/messages/${id}/read`),
  deleteMessage: (id) => apiClient.delete(`/api/admin/messages/${id}`),

  // 上传
  uploadImage: (formData) =>
    apiClient.post("/api/admin/upload/image", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
};

export default apiClient;
